import { AxiosRequestConfig } from "axios";

import axioInstance from "@/libs/axios";
import { QuotePayload } from "@/types/quote/quote-data";

// const baseURL = "http://localhost:3000/api";
const saveQuestionData = async (
  payload: QuotePayload,
  config?: AxiosRequestConfig
) => {
  const saveInitDataResponse = await axioInstance.post(
    `/saveInitData`,
    {
      data: payload,
    },
    config
  );

  return saveInitDataResponse?.data;
};

export default saveQuestionData;
